export const CONSULT_PRICE_RETRIEVE_REQUESTED = 'CONSULT_PRICE_RETRIEVE_REQUESTED';
export const CONSULT_PRICE_RETRIEVE_SUCCEED = 'CONSULT_PRICE_RETRIEVE_SUCCEED';
export const CONSULT_PRICE_RETRIEVE_FAILED = 'CONSULT_PRICE_RETRIEVE_FAILED';

export const CONSULT_PRICE_UPDATE_REQUESTED = 'CONSULT_PRICE_UPDATE_REQUESTED';
export const CONSULT_PRICE_UPDATE_SUCCEED = 'CONSULT_PRICE_UPDATE_SUCCEED';
export const CONSULT_PRICE_UPDATE_FAILED = 'CONSULT_PRICE_UPDATE_FAILED';

export const CONSULT_FEE_ESTIMATE_REQUESTED = 'CONSULT_FEE_ESTIMATE_REQUESTED';
export const CONSULT_FEE_ESTIMATE_SUCCEED = 'CONSULT_FEE_ESTIMATE_SUCCEED';
export const CONSULT_FEE_ESTIMATE_FAILED = 'CONSULT_FEE_ESTIMATE_FAILED';

export const CONSULT_PRICE_RESET = 'CONSULT_PRICE_RESET';
